import React, { memo } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";

/* Sub 메뉴 layout
    SUBS : Sub 메뉴 리스트
    code : 현재 선택된 메뉴 code
*/
export const SubMenu = memo((props) => {
    const { SUBS, code } = props;

    return (
        <div className="top-roundtab-contain">
            <ul className={SUBS.length === 2 ? "w2" : SUBS.length === 3 ? "w3" : null}>
                {SUBS.map((m, i) => (
                    <li key={i}><Link to={m.url} className={cx({ on: code === m.code })}>{m.label}</Link></li>
                ))}
            </ul>
        </div>
    );
});
